import { EpisodeState } from "@/api/episodes-types";
import { Loader } from "@/components/ui/loaders";
import { useEpisodeById } from "@/queries/episodes/use-episode-by-id";
import { useAddTag } from "@/queries/episodes/use-tags";
import { useTagModalStore } from "@/stores/tag-modal-store";
import { Stack, Typography } from "@mui/material";
import { Tag } from "./Tag";
import { TagsDropdown } from "./TagsDropdown";

type TagsRowProps = {
  episodeId: string;
};

export function TagsRow({ episodeId }: TagsRowProps) {
  const { mutate: onAddTag, isPending: isAddTagPending } = useAddTag();

  const { isTagRemovePending } = useTagModalStore();

  const { data: episode } = useEpisodeById(episodeId);

  return (
    <Stack direction={"row"} alignItems="center" gap={1}>
      <Typography color="textSecondary">Tags:</Typography>
      {episode && episode.tags.length > 0 && (
        <>
          <Loader isLoading={isAddTagPending || isTagRemovePending} size={16} />
          {episode.tags.map((tag) => (
            <Tag
              key={tag}
              text={tag}
              episodeId={episodeId}
              episodeState={episode?.state}
              disabled={isAddTagPending || isTagRemovePending}
            />
          ))}
        </>
      )}
      {episode && episode.state !== EpisodeState.rejected && (
        <TagsDropdown
          sx={{ height: 20, fontSize: 12, borderRadius: 4 }}
          disabled={isAddTagPending || isTagRemovePending}
          tagsToExclude={episode.tags}
          onChange={(tag) => onAddTag({ episodeIds: [episodeId], tag })}
        />
      )}
    </Stack>
  );
}
